import { createContext, ReactNode, useContext } from 'react';
import { useFieldManagerData } from './useFieldManagerData';

type FieldManagerDataContextValue = ReturnType<typeof useFieldManagerData>;

const FieldManagerDataContext =
  createContext<FieldManagerDataContextValue | null>(null);

export const useFieldManagerDataContext = (): FieldManagerDataContextValue => {
  const context = useContext(FieldManagerDataContext);

  if (!context) {
    throw new Error(
      'useFieldManagerDataContext must be used within a FieldManagerDataProvider'
    );
  }

  return context;
};

export const FieldManagerDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const data = useFieldManagerData();

  return (
    <FieldManagerDataContext.Provider value={data}>
      {children}
    </FieldManagerDataContext.Provider>
  );
};
